$(function(){

	$('.page-cb-startpage-slider-items').owlCarousel(
		{
			items: 1,
			loop: true,
			dots: true,
			nav: false,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			// transitionStyle : "fade",
			lazyLoad: true,
			autoplay: true, // false,
			autoplayTimeout: 5000,
			autoplayHoverPause: true

		}
	);

});